export const SHOW_MORE_WIDTH = 30;
export const ITEMS_GAP = 5;
export const LABEL_WIDTH = '125px';
export const ITEM_MAX_WIDTH = '188px';
